import { Profile as ProfileComponent } from '../components/profile/Profile'
import { useState } from 'react'
import { IUser } from '../types/user'
import { useEffect } from 'react'
import { user as userAPI } from '../utils/api/index'
import { useParams } from 'react-router'
import {
    OGSetDescription,
    OGSetImage,
    OGSetTitle,
    OGTitleHelper,
    OGUpdateUrl,
} from '../utils/openGraph'
import { getUserName } from '../utils/methods'
import { UserCards } from '../components/profile/Cards'
import { EventContext } from '../ctx/event'
import { Container } from '../components/Container'

export const User = () => {
    const { id } = useParams<{ id: string }>()
    const [user, setUser] = useState<IUser>()

    useEffect(() => {
        userAPI.metanameOrId(id.replace(/@/, '')).then(({ data }) => {
            setUser(data)
            OGSetTitle(OGTitleHelper(getUserName(data)))
            OGSetDescription(data.description)
            OGSetImage(data.avatar || '')
            OGUpdateUrl()
        })
    }, [id])

    return (
        <EventContext.Provider value={{ onFollowed: setUser }}>
            {user && (
                <>
                    <ProfileComponent user={user}></ProfileComponent>
                    <Container>
                        <UserCards user={user}></UserCards>
                    </Container>
                </>
            )}
        </EventContext.Provider>
    )
}
